import * as theme from "./Content.css";

interface ContentProps {
    children: React.ReactNode;
    body: string;
}

export function Content({ children, body }: ContentProps) {
    return (
        <div className={theme.content}>
            <p>{body}</p>
            {children}
        </div>
    );
}
